export const DOCUMENT_UPLOADED = "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.Documents.DocumentUploaded";
export const DOCUMENT_UPLOADED_WITH_STATE_UPDATE =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.Documents.DocumentUploadedWithStateUpdate";
export const DOCUMENTS_SIGNEES_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.Documents.DocumentSigneesUpdated";
export const DOCUMENT_SIGNEES_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.Documents.DocumentSigneesInvalidated";
export const EXPORT_DOCUMENT_LIST_EXECUTED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.Documents.ExportDocumentListExecuted";
export const EXPORT_DOCUMENT_EXECUTED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.Documents.DocumentExported";
export const PRINT_DOCUMENTS_EXECUTED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.Documents.PrintDocumentsExecuted";
export const DOCUMENTS_READY_FOR_SEND_EMAIL =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.Documents.DocumentsExportedAndReadyForEmail";
export const DOCUMENT_LIST_EXPORTED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.Documents.DocumentListExported";
export const EXPORT_DOCUMENT_LIST_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.Documents.ExportDocumentListInvalidated";
export const EXPORT_DOCUMENT_LIST_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.Documents.ExportDocumentListUpdated";
export const DOCUMENT_LIST_SIGNED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.Documents.DocumentListSigned";
export const DOCUMENT_PRINT_SIGNING_RESET =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.Documents.DocumentPrintSigningReset";
export const DOCUMENT_PARTNERS_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.Documents.DocumentPartnersInvalidated";

export const DOCUMENT_WORKFLOW_ERROR_DISMISSED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingDocument.Documents.DocumentWorkflowErrorDismissed";
